import { type Module, ValidationModule } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import { forwardRef, useMemo } from 'react';
import type { SizeColumnsToFitGridStrategy } from 'ag-grid-community';
import type { AgGridProps } from './grid.types';

export const AgGrid = forwardRef<AgGridReact, AgGridProps>((props, ref) => {
  const { modules, ...rest } = props;

  const agModules = useMemo(
    (): Module[] =>
      modules.concat(
        // This helps to debug the AgGrid component in the browser console, also informs the user about the AgGrid
        // modules missing - https://www.ag-grid.com/angular-data-grid/modules/#development-validations
        process.env.NODE_ENV !== 'production' ? [ValidationModule] : [],
      ),
    [modules],
  );

  const agProps = {
    autoSizeStrategy:
      // auto-sizing can fail unit tests because it waits a fixed amount of time for the grid to render (CRAB-49618).
      // Development uses it too so grids are sized the same way they are in production.
      process.env.NODE_ENV !== 'test' ? ({ type: 'fitGridWidth' } satisfies SizeColumnsToFitGridStrategy) : undefined,
    ...rest,
    modules: agModules,
  };

  return <AgGridReact {...agProps} ref={ref} theme="legacy" />;
});
AgGrid.displayName = 'AgGrid';
